import { Module } from "vuex";

import { RootStateType } from "@/store";

import actions from "./actions";
import mutations from "./mutations";
import { ContractProfileState } from "./model";

let state: ContractProfileState = {
  contractProfiles: []
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
} as Module<ContractProfileState, RootStateType>;
